import {Modal} from '@/components/atoms'
import {SaveCancelFooter} from '@/components/molecules'
import {useBaseDataEditHook} from '@/containers/ProductReviewEditContainer/BaseEdit/BaseDataEditHook'
import ProductInformation from '@/containers/ProductReviewEditContainer/BaseEdit/ProductInformation/ProductInformation'
import {selectIsIndia} from '@/store/slices/countryCodeSlice'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'
import {useState} from 'react'
import {useSelector} from 'react-redux'
import './baseDataEdit.scss'

const BaseDataEdit = ({formData, onDataChange, onPublish}) => {
  const [shouldShowModal, setShouldShowModal] = useState(false)
  const {baseDataFields, categoryListData, handleFormChange, additionaInfoFields, handleCancel} = useBaseDataEditHook({
    onDataChange,
  })
  const isIndia = useSelector(selectIsIndia)

  const formError = product => {
    if (!product.name || (!product?.productTypeId && !isIndia) || !product.sizeId) return false

    if (
      !isIndia &&
      (!product.productTypeByLocale ||
        typeof product.productTypeByLocale !== 'object' ||
        Object.values(product.productTypeByLocale).some(value => !value))
    ) {
      return false
    }

    // For India: only English (`en`) is required for display product size.
    if (isIndia) {
      if (!product.sizeByLocale || typeof product.sizeByLocale !== 'object' || !product.sizeByLocale['en']) {
        return false
      }
    } else {
      if (
        !product.sizeByLocale ||
        typeof product.sizeByLocale !== 'object' ||
        Object.values(product.sizeByLocale).some(value => !value)
      ) {
        return false
      }
    }

    return true
  }
  return (
    <div className="base-data-edit">
      <ProductInformation
        baseDataFormData={formData}
        handleFormChange={handleFormChange}
        categoryListData={categoryListData}
        baseDataFields={baseDataFields}
        additionaInfoFields={additionaInfoFields}
        isMandatory={!isIndia}
      />

      {shouldShowModal && (
        <Modal
          type={MODAL_TYPE.SMALL}
          showModal={shouldShowModal}
          onCloseModal={() => setShouldShowModal(false)}
          title="Are you sure you want to cancel?"
          text={'The changes will not be saved.'}
          showPrimaryButton={true}
          primaryButtonText="Yes"
          onClickPrimaryButton={handleCancel}
          showSecondaryButton={true}
          secondaryButtonText="No"
          onClickSecondaryButton={() => setShouldShowModal(false)}
          footerProps={{
            size: 'medium',
            type: 'primary',
          }}
          isDark={true}
        />
      )}

      <SaveCancelFooter
        handleCancel={() => setShouldShowModal(value => !value)}
        nextAction={() => {
          onPublish()
        }}
        isReview={true}
        hideSaveDraft={true}
        FormError={!formError(formData.baseData)}
      />
    </div>
  )
}

export default BaseDataEdit
